// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__1K1k-","SocialLinks":"Home_SocialLinks__2jMmz","Right":"Home_Right__16FOv"};